// Начальный экран загрузки: пульсирующее название магазина по центру.
export default function Splash({ error }: { error?: string | null }) {
  return (
    <div className="splash">
      <div className="splash__brand">
        Storosilov
        <br />
        Vintage
      </div>
      {error
        ? <div style={{ color: "#b00020", fontSize: 14 }}>Ошибка: {error}</div>
        : <div className="splash__sub">загружаем магазин…</div>}
    </div>
  );
}
